import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { locationsSelector } from "../../../store/slices/location";
import { Select,Checkbox,MenuItem,Box, useTheme,ListItemText,Stack,Typography} from "@mui/material";
import _ from 'lodash'
import { convertArrayToDictionary, getSourceIcon } from "../../../common/utils";
import { companiesSelector } from "../../../store/slices/company";
import { setReviewSourceFilter } from "../../../store/slices/reviews";
import { localSelector } from "../../../store/slices/local";

const SourceFilter = ({}) => {
  const [reviewSource, setReviewSource] = useState(-1)
  const [sourceArr, setSourceArr] = React.useState([])
  const {companies}=useSelector(companiesSelector)
  const dispatch=useDispatch()
  const {sourceTypes}=useSelector(locationsSelector)
  const {selectedCompany}=useSelector(localSelector)
  const theme=useTheme()
  const companyDic=useMemo(()=>convertArrayToDictionary(companies,'companyId'),[companies])
  const selectedCompanyMemo=useMemo(()=>companyDic[selectedCompany],[companyDic,selectedCompany])
  const companySources = useMemo(() =>{ 
        
    return   _.map(selectedCompanyMemo?.sources?.split(','),it=>_.parseInt(it))}, [selectedCompanyMemo])
  const sourceDropDownList = useMemo(() => filterByValues(companySources), [sourceTypes])
  const makeSourceName = (value) => {
        
    if( _.includes(value, -1)){
            return "All"
    }
    else{
        const temp1=_.filter(sourceDropDownList, it => _.includes(value, it.value))
         // const temp1=_.filter(sourceDropDownList, it => _.includes(_.map(sources, a => a.sourceId), it.value))
    return  _.join(_.map(temp1,'label'), ", ");
    }
};


  const handleSourceChange = (value, isSingleSelect) => {
    let finalValue;
    const sourceDnDcomp = _.map(_.filter(sourceDropDownList, it => it.value !== -1), a => a.value)
    if (!isSingleSelect) {
        if (value === -1|| reviewSource == value) {
            finalValue = _.map(sourceDropDownList, it => it.value)
        }

        else {
            finalValue = _.includes(sourceArr, value) ? _.filter(sourceArr, it => it !== value) : [...sourceArr, value]
            finalValue = _.isEqual(finalValue, sourceDnDcomp) ? [...finalValue, -1] : _.filter(finalValue, it => it !== -1)
        }
    }
    else if (isSingleSelect) {
        finalValue = [value]
    }

    setReviewSource(
        // On autofill we get a stringified value.
        typeof finalValue !== 'string' ? finalValue.join(',') : finalValue
    );
     localStorage.setItem('sourceFilter',JSON.stringify({[selectedCompany]:typeof finalValue !== 'string' ? finalValue.join(',') : finalValue}))
    setSourceArr(finalValue)
    dispatch(setReviewSourceFilter(_.split(finalValue,',')))

};
function filterByValues(arrOfIntegers) {

    const sourceList = _.map(_.clone(sourceTypes), it => ({ value: it.sourceTypeId, label: it?.name }))
    const finalData = sourceList
    if (_.size(finalData) > 1) {
        finalData.unshift({ value: -1, label: 'All' })
       
          
        
    }
    // else {
    //     if(_.size(sourceList)>0){
    //         localStorage.setItem('sourceFilter',JSON.stringify({[companyId]:sourceList[0]?.value}))
    //         setReviewSource(sourceList[0]?.value)
    //     }
    // }
    //  setReviewSource(sourceList[0]?.value)
    return finalData
}
const bindSourceValue = (reviewSource) => {
    let source = _.map(_.split(reviewSource, ','), it => { return parseInt(it) });
    if (_.isEqual(source, [-1])) {
        source = [-1, ..._.map(sourceTypes, it => it.sourceTypeId)];
    }
    return source
}
const sourceValues = React.useMemo(() => bindSourceValue(reviewSource), [reviewSource]);
  return (<Select
    multiple
    size="small"
    sx={{
        width: "180px",
        height: "44px",
        borderRadius: "8px",
        transition: 'all 0.3s ease-in-out',
        paddingLeft: '5px',
        paddingRight: '10px',

    }}
    MenuProps={{
        sx: {
            "&& .Mui-selected": {
                backgroundColor: "unset",
                ":hover": {
                    backgroundColor: theme => theme.palette.action.hover
                }
            }
        },
        slotProps: {
            backdrop: {
                sx: {
                    backgroundColor: "transparent !important",

                },
            },
        },
        PaperProps: {
            sx: {
                p: 0,
                border: `1px solid  ${theme.palette.divider}`,
                boxShadow: theme.shadows[16],
                // position: 'absolute',
                // top: '68px !important'
            },
        },
    }}
    value={sourceValues}
    //  onChange={(e) => handleSourceChange(e)}
    renderValue={(value) => {
        return (
            <Box sx={{ display: "flex", alignItems: 'center' }}>
                <svg
                    class="globe-02"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ marginRight: '6px' }}
                >
                    <g clip-path="url(#clip0_162_15351)">
                        <path
                            d="M10.0003 1.66669C12.0847 3.94865 13.2693 6.91005 13.3337 10C13.2693 13.09 12.0847 16.0514 10.0003 18.3334M10.0003 1.66669C7.91593 3.94865 6.73137 6.91005 6.66699 10C6.73137 13.09 7.91593 16.0514 10.0003 18.3334M10.0003 1.66669C5.39795 1.66669 1.66699 5.39765 1.66699 10C1.66699 14.6024 5.39795 18.3334 10.0003 18.3334M10.0003 1.66669C14.6027 1.66669 18.3337 5.39765 18.3337 10C18.3337 14.6024 14.6027 18.3334 10.0003 18.3334M2.08367 7.50002H17.917M2.08366 12.5H17.917"
                            stroke="#344054"
                            stroke-width="1.67"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_162_15351">
                            <rect width="20" height="20" fill="white" />
                        </clipPath>
                    </defs>
                </svg>

                {makeSourceName(value)}
            </Box>
        );
    }}
>
    {_.map(sourceDropDownList, (item,index )=> {
        return <MenuItem autoFocus={index===0}   key={item?.value} value={item?.value} sx={{ py: 0 }}>
            <Checkbox
                zIndex={'1'}
                checked={item?.value != 0 && !_.includes(sourceValues, item?.value) ? _.isEqual(sourceValues, [-1]) : _.includes(sourceValues, item?.value)}
                onChange={(e) => { handleSourceChange(item.value, false);}}
            // indeterminate={isIntermediate}
            />
            <ListItemText
                onClick={(e) => { handleSourceChange(item.value, true);}}
                primary={<Stack direction={'row'} spacing={1} alignItems={'center'}>{getSourceIcon(item?.value,16, (item?.label === 'All'? true: false))}<Typography>{item?.label}</Typography></Stack>}
            />
        </MenuItem>
    })}

</Select>);
};

export default SourceFilter;
